import makeStyles from '@mui/styles/makeStyles'

export const useExtraBetmenListItemCardStyle = makeStyles((theme) => ({
  container: {
    cursor: 'pointer',
    borderWidth: 2,
    borderColor: theme.palette.grey[300],
    '&:hover': {
      background: theme.palette.grey[50],
    },
  },
  hovered: {
    borderColor: theme.palette.grey[800],
    borderWidth: 2,
  },
  past: {
    color: theme.palette.grey[600],
    background: theme.palette.grey[200],
    '&:hover': {
      background: theme.palette.grey[300],
    },
  },
}))
